import { formatDate } from '@angular/common';
import { Component, HostListener, OnDestroy, OnInit } from '@angular/core';
import {
  FormControl,
  UntypedFormControl,
  UntypedFormGroup,
  Validators,
} from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { Location } from '@angular/common';
import {
  areObjectsEqual,
  getFormattedDate,
  getFormattedTime,
  getNextQuarterHour,
  getStartAndEndTime,
  isLargeScreen,
} from '../../../../../global.variable';
import { ConfirmDialogComponent } from '../../../../shared/components/confirm-dialog/confirm-dialog.component';
import { ModalDialogueService } from '../../../../shared/components/modal-dialogue/modal-dialogue.service';
import { LoadingSpinnerService } from '../../../../shared/services/loading-spinner.service';
import { ToasterService } from '../../../../shared/services/toaster.service';
import { JobsService } from '../../jobs/jobs.service';
import { RunSheetService } from '../runsheet.service';
import { v4 as uuidv4 } from 'uuid';
@Component({
  selector: 'gtapp-add-runsheet',
  templateUrl: './add-runsheet.component.html',
  styleUrl: './add-runsheet.component.scss',
  standalone: false,
})
export class AddRunSheetComponent implements OnInit, OnDestroy {
  schedulerForm: UntypedFormGroup = new UntypedFormGroup({
    end_time: new FormControl(null),
    start_time: new FormControl(null),
    start_day: new FormControl(new Date()),
    end_day: new FormControl(null, Validators.required),

    repeat_times: new UntypedFormControl(null),
    repeat_type: new UntypedFormControl(null, Validators.required),
    repeat_details: new UntypedFormControl([]),
    repeat_interval: new UntypedFormControl(1, [
      Validators.required,
      Validators.pattern('^[0-9]*$'),
    ]),
    position: new UntypedFormControl(null, []),
    week_day: new UntypedFormControl(null, []),
    month_repeat_case: new UntypedFormControl(null, []),
  });

  scheduleStepperActive: boolean = false;

  addRunSheetPressed: boolean = false;

  currentStep: number = 1;
  runSheetName: string = '';

  assigneeList: any = [];
  initalAssigneeListData: any = [];
  assignedGuardData: any;

  checkListData: any = [];
  formattedRunSheetTasks: any = [];

  runSheetSuggestionsDataList: any = [];
  runSheetSearchSuggestionsDataList: any = [];
  selectedSuggestedRunsheet: any;

  scheduleDatesDict: any = {};

  mainScheduleBackupDict: any = {};

  runSheetJobType: any = {};

  largeView = isLargeScreen;

  showSuggestionNum: number = 10;

  draftedRunsheet: any;
  routedFromSchedule: boolean = false;

  constructor(
    private route: ActivatedRoute,
    private runSheetService: RunSheetService,
    private jobService: JobsService,
    private dialogService: ModalDialogueService,
    private spinnerService: LoadingSpinnerService,
    private toasterService: ToasterService,
    private router: Router,
    private _location: Location,
  ) {}
  ngOnInit(): void {
    const lastNav = this.router?.lastSuccessfulNavigation;

    const previousUrl = lastNav?.previousNavigation?.finalUrl?.toString();
    this.routedFromSchedule = !!previousUrl?.includes('/schedule');

    this.getJobTypes();
    this.getRunsheetSuggestions();
    const rKey = this.route.snapshot.paramMap.get('rKey');

    if (rKey) {
      sessionStorage.removeItem(btoa('runsheetDraft'));
      this.getRunsheetDetailData(rKey);
    } else {
      this.saveAndLoadFromSession('load');
    }
  }
  ngOnDestroy(): void {
    if (this.runSheetName) this.saveAndLoadFromSession();
  }
  @HostListener('window:beforeunload')
  beforeUnloadHandler() {
    // reloading page is not triggering ngOnDestory
    if (this.runSheetName) this.saveAndLoadFromSession();
  }
  shiftFocus(elementId: string) {
    setTimeout(() => {
      var element = <HTMLInputElement>document.getElementById(elementId);

      element?.focus();
    }, 200);
  }
  getAssignees(params?: any) {
    this.jobService.getUserList(params).subscribe(async (response: any) => {
      if (response['status'] == 'success') {
        if (!params) {
          this.initalAssigneeListData = JSON.parse(
            JSON.stringify(response?.data),
          );
        }
        this.assigneeList = [...response?.data];
      }
    });
  }
  editField(field: string) {
    if (field == 'assignee') {
      this.assignedGuardData = {};

      this.shiftFocus('assigneeId');
    }
    if (field == 'runSheetInputField') {
      this.runSheetName = '';
      this.shiftFocus('runSheetInputField');
    }

    this.updateInitialDataList();
  }

  updateInitialDataList() {
    setTimeout(() => {
      this.assigneeList = JSON.parse(
        JSON.stringify(this.initalAssigneeListData),
      );
    }, 200);
  }
  onAssigneeSelect(assignee: any) {
    this.assignedGuardData = { ...assignee };
  }

  onAssigneeSearch(event: any) {
    if (event.target.value?.length > 0) {
      this.getAssignees({ search_str: event?.target?.value });
    } else {
      this.updateInitialDataList();
    }
  }
  getStartAndEndDateTime(shift: any) {
    let startDateTime = new Date();
    let endDateTime = new Date();
    if (shift?.repeat_type == 'once') {
      startDateTime = new Date(shift?.start_day + ' ' + shift?.start_time);
      endDateTime = new Date(shift?.end_day + ' ' + shift?.end_time);
    } else {
      startDateTime = new Date(shift?.event_date + ' ' + shift?.start_time);
      endDateTime = new Date(shift?.event_date + ' ' + shift?.end_time);
      if (shift?.end_time < shift?.start_time) {
        // overnight schedule
        endDateTime.setDate(endDateTime.getDate() + 1);
      }
    }

    return [startDateTime.getTime(), endDateTime.getTime()];
  }

  formatScheduleForm() {
    let passedDate = sessionStorage.getItem('selectedRosterDate') || new Date();

    let [startDateTime, endDateTime] = getStartAndEndTime(
      passedDate ? new Date(passedDate) : new Date(),
    );

    if (this.selectedSuggestedRunsheet?.id) {
      if (this.draftedRunsheet?.schedulerForm && this.routedFromSchedule) {
        this.schedulerForm.patchValue(this.draftedRunsheet?.schedulerForm);
        this.scheduleStepperActive = true;

        return;
      }
      // take schedule from the prefilled info
      const preFillSchedule = this.selectedSuggestedRunsheet?.roster_scheduler;

      startDateTime = new Date(
        (this.selectedSuggestedRunsheet?.event_date ||
          preFillSchedule?.start_day) +
          ' ' +
          preFillSchedule?.start_time,
      );

      // check start time is greater than midnight today
      const todayMidnight = new Date();
      todayMidnight.setHours(0, 0, 0, 0);

      if (startDateTime < todayMidnight) {
        const startDateTimeCopy = new Date(startDateTime);
        startDateTime = new Date();
        startDateTime.setHours(
          startDateTimeCopy.getHours(),
          startDateTimeCopy.getMinutes(),
          0,
          0,
        );
      }

      endDateTime = new Date(
        (this.selectedSuggestedRunsheet?.event_date ||
          preFillSchedule?.end_day) +
          ' ' +
          preFillSchedule?.end_time,
      );

      if (endDateTime.getTime() < startDateTime.getTime()) {
        // end time less than start time
        const endDateBackup = new Date(endDateTime);
        endDateTime = new Date();
        endDateTime.setHours(
          endDateBackup.getHours(),
          endDateBackup.getMinutes(),
          0,
          0,
        );
      }
      if (endDateTime.getTime() < startDateTime.getTime()) {
        // overnight cases
        endDateTime.setDate(startDateTime.getDate() + 1);
      }
      if (endDateTime.getTime() < new Date().getTime()) {
        // start and end times have expired for the current day
        endDateTime.setDate(new Date().getDate() + 1);
        startDateTime.setDate(new Date().getDate() + 1);
      }
    } else {
      if (this.draftedRunsheet?.schedulerForm) {
        this.schedulerForm.patchValue(this.draftedRunsheet?.schedulerForm);
        this.scheduleStepperActive = true;

        return;
      }
    }
    sessionStorage.removeItem('selectedRosterDate');
    this.schedulerForm.controls['repeat_type'].setValue('once');
    this.schedulerForm.controls['repeat_details'].setValue([]);
    this.schedulerForm.controls['end_day'].setValue(
      getFormattedDate(endDateTime),
    );
    this.schedulerForm.controls['end_time'].setValue(
      getFormattedTime(endDateTime),
    );

    this.schedulerForm.controls['start_day'].setValue(
      getFormattedDate(startDateTime),
    );
    this.schedulerForm.controls['start_time'].setValue(
      getFormattedTime(startDateTime),
    );
    this.scheduleStepperActive = true;
  }
  preFormatScheduleForApi(schedule: any) {
    let formattedSchedule: any = {};
    if (schedule?.start_datetime) {
      formattedSchedule.start_day = getFormattedDate(schedule?.start_datetime);
      formattedSchedule.start_time = getFormattedTime(schedule?.start_datetime);
    }
    if (schedule?.end_datetime) {
      formattedSchedule.end_day = getFormattedDate(schedule?.end_datetime);
      formattedSchedule.end_time = getFormattedTime(schedule?.end_datetime);
    }
    if (schedule?.start_time) {
      formattedSchedule.start_time = schedule?.start_time;
    }
    if (schedule?.end_time) {
      formattedSchedule.end_time = schedule?.end_time;
    }
    if (schedule?.repeat_details?.length) {
      formattedSchedule.repeat_details = schedule?.repeat_details;
    }

    formattedSchedule.reminder = schedule?.reminder;

    return formattedSchedule;
  }
  formatRunSheetTasks() {
    this.formattedRunSheetTasks = [];
    let index = 0;

    this.checkListData?.forEach((checkList: any) => {
      let updatedCheckList: any = [];
      const siteId = checkList?.site?.id || 0;
      if (checkList?.tasks?.length) {
        checkList?.tasks?.forEach((task: any) => {
          if (task?.note?.trim()) {
            index += 1;
            updatedCheckList.push({
              notes: task?.note?.trim(),
              user_prompt_id: task?.user_prompt_id,
              schedule: this.preFormatScheduleForApi(task?.schedule),
              order: index,
            });
          }
        });
      }

      if (checkList?.enable_reporting && !updatedCheckList?.length) {
        index += 1;

        updatedCheckList.push({
          notes: null,
          order: index,
        });
      }

      if (updatedCheckList?.length) {
        const checkListDataDict: any = {
          tasks: updatedCheckList,
          site_id: siteId,
          check_list_schedule_uuid: uuidv4(),
        };
        if (siteId && checkList?.enable_reporting && this.runSheetJobType?.id) {
          checkListDataDict['create_job'] = {
            company_id: checkList?.site?.company?.id,
            job_type_id: this.runSheetJobType?.id,
          };
          const checkpointIds = checkList?.selectedCheckpoints
            ?.map((item: any) => item?.id)
            ?.filter(Boolean);
          checkListDataDict['checkpoint_ids'] = checkpointIds || [];
        }

        this.formattedRunSheetTasks.push(checkListDataDict);
      }
    });
  }
  saveAndLoadFromSession(action: 'save' | 'load' = 'save') {
    if (action === 'save') {
      sessionStorage.setItem(
        btoa('runsheetDraft'),
        JSON.stringify({
          runSheetName: this.runSheetName,
          assignedGuardData: this.assignedGuardData,
          checkListData: this.checkListData,
          schedulerForm: this.schedulerForm.value,
        }),
      );
    } else {
      this.draftedRunsheet = JSON.parse(
        sessionStorage.getItem(btoa('runsheetDraft')) || '{}',
      );

      if (this.draftedRunsheet && Object.keys(this.draftedRunsheet)?.length) {
        this.runSheetName = this.draftedRunsheet?.runSheetName;
        this.assignedGuardData = this.draftedRunsheet?.assignedGuardData;
        this.checkListData = this.draftedRunsheet?.checkListData;
        this.schedulerForm.patchValue(this.draftedRunsheet?.schedulerForm);
      }
    }
  }

  onAddRunSheet() {
    this.addRunSheetPressed = true;
    this.spinnerService.show('Saving Scheduled Patrol');

    let data: any = {
      name: this.runSheetName,
      subscriber_user_id: this.assignedGuardData?.id,
      check_list_data: this.formattedRunSheetTasks,
    };
    let params: any = {};

    this.schedulerForm.value.start_day = formatDate(
      this.schedulerForm.value.start_day,
      'yyyy-MM-dd',
      'en',
    );

    this.schedulerForm.value.end_day = formatDate(
      this.schedulerForm.value.end_day,
      'yyyy-MM-dd',
      'en',
    );
    let timezoneOffset = new Date();

    data = {
      time_offset: timezoneOffset.getTimezoneOffset(),
      ...this.schedulerForm.value,
      ...data,
    };

    this.runSheetService
      .createRunSheet(data, params)
      .then((res: any) => {
        if (res['status'] == 'success') {
          this.runSheetName = '';
          sessionStorage.removeItem(btoa('runsheetDraft'));
          this.router.navigate(['/schedule'], {
            fragment: getFormattedDate(this.schedulerForm.value.start_day),
          });
        } else {
          this.addRunSheetPressed = false;
          this.toasterService.setMessage({
            errorMessage: res['message'],
            successMessage: '',
          });
          this.spinnerService.hide();
        }
      })
      .catch((error: any) => {
        if (error) {
          this.addRunSheetPressed = false;
        }
      });
  }
  goBack() {
    this._location.back();
  }

  formatTaskStep(direction: string) {
    // check if the main schedule changed if so change the task schedule also. possibly try to auto fill
    if (direction === 'forward') {
      this.checkListData = this.checkListData?.length
        ? this.checkListData
        : [{ tasks: [{}] }];
    } else {
      this.mainScheduleBackupDict = JSON.parse(
        JSON.stringify(this.schedulerForm.value),
      );
    }
  }
  onRunsheetSuggestionSearch(event: any) {
    this.getRunsheetSuggestions(event.target.value);
  }
  getRunsheetSuggestions(searchStr?: string) {
    let reqParams: any = { rows: this.showSuggestionNum };
    if (searchStr) reqParams.search_str = searchStr;
    this.runSheetService
      .getRunsheetSuggestions({}, reqParams)
      .then((response: any) => {
        if (response['status'] == 'success') {
          if (searchStr) {
            this.runSheetSearchSuggestionsDataList = response?.data;
          } else {
            this.runSheetSuggestionsDataList = response?.data;
            this.runSheetSearchSuggestionsDataList = response?.data;
          }
        } else {
          this.toasterService.setMessage({
            successMessage: '',
            errorMessage: response['message'],
          });
        }
      });
  }
  onSelectRunsheet(event: any) {
    this.selectSuggestedRunsheet({ id: event.target.value });
  }
  selectSuggestedRunsheet(runsheetData: any) {
    const dialogRef = this.dialogService.open(ConfirmDialogComponent, {
      data: {
        title: 'Are you sure?',
        message: `Preload tasks from previous patrol?`,
      },
    });
    dialogRef.afterClosed().subscribe((value: any) => {
      if (value === true) {
        sessionStorage.removeItem(btoa('runsheetDraft'));
        if (!this.routedFromSchedule) this.draftedRunsheet = null;
        this.getRunsheetDetailData(runsheetData?.id, true);
      }
    });
  }

  getRunsheetDetailData(runsheetId: any, loadOnlyTasks = false) {
    this.spinnerService.show('Preloading data');

    this.runSheetService
      .getRunsheetSuggestions({}, { runsheet_id: runsheetId })
      .then((response: any) => {
        if (response['status'] == 'success') {
          this.spinnerService.hide();
          if (loadOnlyTasks) {
            this.checkListData = response?.data?.check_list_data;
            this.updateCheckListAndTaskWithSchedule();
            this.formatRunSheetTasks();
            return;
          }
          this.selectedSuggestedRunsheet = response?.data;

          this.formatScheduleForm();
          if (this.runSheetName) {
            this.currentStep = 2;
          } else {
            this.runSheetName = this.selectedSuggestedRunsheet?.name;
            this.currentStep = 1;
          }

          this.checkListData = this.selectedSuggestedRunsheet?.check_list_data;
          this.formatRunSheetTasks();
          this.assignedGuardData = this.selectedSuggestedRunsheet?.assignee;
        } else {
          this.spinnerService.hide();
          this.toasterService.setMessage({
            successMessage: '',
            errorMessage: response['message'],
          });
        }
      });
  }
  updateCheckListAndTaskWithSchedule() {
    const updatedCheckLists: any = [];
    this.checkListData?.forEach((chklist: any) => {
      const updatedTasks: any = [];
      if (chklist?.tasks?.length) {
        chklist?.tasks?.forEach((task: any) => {
          if (
            !task?.scheduleAdded &&
            (task?.note || chklist?.enable_reporting)
          ) {
            if (task?.schedule?.repeat_details?.length) {
              const updatedRepeatDetails =
                task?.schedule?.repeat_details?.filter((item: any) =>
                  this.scheduleDatesDict?.weekdays?.includes(item),
                );

              if (updatedRepeatDetails?.length) {
                task.schedule.repeat_details = updatedRepeatDetails;
                updatedTasks.push(task);
              } else {
                task.schedule = null;
                updatedTasks.push(task);
              }
            } else {
              task.schedule = null;
              updatedTasks.push(task);
            }
          }
        });
      } else if (chklist?.enable_reporting) {
        updatedCheckLists.push({ ...chklist, tasks: [{}] });
      }
      if (updatedTasks?.length) {
        updatedCheckLists.push({ ...chklist, tasks: updatedTasks });
      }
    });
    this.checkListData = JSON.parse(JSON.stringify(updatedCheckLists));
  }

  getEventDates() {
    this.spinnerService.show();
    let params: any = {
      get_dates: 1,
      schedule: JSON.stringify(this.schedulerForm.value),
    };

    this.runSheetService.getRunSheets(params).subscribe((response: any) => {
      if (response['status'] == 'success') {
        this.scheduleDatesDict = response?.data;
        this.spinnerService.hide();

        const hasScheduleChanged = Boolean(
          this.selectedSuggestedRunsheet?.id ||
          (Object.keys(this.mainScheduleBackupDict)?.length &&
            !areObjectsEqual(
              this.mainScheduleBackupDict,
              this.schedulerForm.value,
            )),
        );

        if (hasScheduleChanged) {
          this.updateCheckListAndTaskWithSchedule();

          this.checkListData = this.checkListData?.length
            ? this.checkListData
            : [{ tasks: [{}] }];
        }
      } else {
        this.spinnerService.hide();
        this.toasterService.setMessage({
          successMessage: '',
          errorMessage: response['message'],
        });
      }
    });
  }

  getJobTypes() {
    this.jobService.getJobParams().subscribe((response: any) => {
      if (response['status'] == 'success') {
        this.runSheetJobType = response?.data?.find(
          (jType: any) => jType?.type_identity === 6,
        );
      }
    });
  }
  onPatrolSummaryClick() {
    if (this.currentStep === 3) return;
    this.currentStep = 3;
    this.getEventDates();
    this.formatTaskStep('forward');
  }

  async scrollToChecklist(index: number) {
    if (this.currentStep != 3) this.onPatrolSummaryClick();
    setTimeout(() => {
      const selectedCheckList: any = document.getElementById(
        'checklistId' + index,
      );
      if (selectedCheckList) {
        selectedCheckList.scrollIntoView({
          behavior: 'smooth',
          block: 'end',
          inline: 'nearest',
        });
        selectedCheckList.click();
      }
    }, 200);
  }
}
